import { PostalAddressDto } from "Store/interfaces/PostalAddressDto";
import { useTexts } from "Store/texts";
import { isDefined } from "Utils/functions";
import React from "react";
import { removeNOPrefix } from "./utils";

interface Props {
  customerAddress: PostalAddressDto | undefined;
}

export const UserAddress = ({
  customerAddress,
}: Props): React.ReactElement | null => {
  const fmsTexts = useTexts();
  if (!isDefined(customerAddress)) {
    return null;
  }

  const { line1, zipCode, city } = customerAddress;
  return (
    <span>
      <b>{fmsTexts.domain["signedInUserInfo.address.label"]}</b>
      {` ${line1}, ${removeNOPrefix(zipCode ?? "")} ${city ?? ""}`}
    </span>
  );
};
